import { ComponentPayloadValidator } from './validators/Component';

import components from './validators/components/all';

import type { ComponentType } from './validators/fields/ComponentType';

const getComponentPayloadValidator = (type: ComponentType) => {
    return components[type]?.validators.payload ?? ComponentPayloadValidator;
};

const getComponentBulkUploadPayloadValidator = (type: ComponentType) => {
    return components[type]?.validators.payload;
};

export { getComponentPayloadValidator, getComponentBulkUploadPayloadValidator };
